var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "login" }, [
    _c(
      "div",
      { staticClass: "top flex flex-vertical" },
      [
        _c("div", { staticClass: "logo" }),
        _c("div", { staticClass: "content" }, [
          _c(
            "div",
            { staticClass: "account-wrap" },
            [
              _vm.loginType === "email"
                ? _c("Input", {
                    staticClass: "phone",
                    attrs: { size: "large", placeholder: _vm.$t("email") },
                    model: {
                      value: _vm.account,
                      callback: function ($$v) {
                        _vm.account = typeof $$v === "string" ? $$v.trim() : $$v
                      },
                      expression: "account",
                    },
                  })
                : _vm._e(),
              _vm.loginType === "mobile"
                ? _c(
                    "div",
                    { staticClass: "email-wrap" },
                    [
                      _c(
                        "Dropdown",
                        {
                          staticClass: "csc-wrap",
                          attrs: {
                            trigger: "click",
                            placement: "bottom-start",
                          },
                          on: { "on-click": _vm.cscClick },
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "csc",
                              attrs: { href: "javascript:void(0)" },
                            },
                            [
                              _c("span", [_vm._v("+")]),
                              _c("span", [_vm._v(_vm._s(_vm.csc))]),
                              _c("div", { staticClass: "icon" }),
                            ]
                          ),
                          _c(
                            "DropdownMenu",
                            { attrs: { slot: "list" }, slot: "list" },
                            [
                              _vm._l(_vm.cscConf, function (item, index) {
                                return [
                                  _c(
                                    "DropdownItem",
                                    { key: index, attrs: { name: item.csc } },
                                    [
                                      _c("div", { staticClass: "left" }, [
                                        _vm._v("+" + _vm._s(item.csc)),
                                      ]),
                                      _c("div", { staticClass: "right" }, [
                                        _vm._v(_vm._s(item.name)),
                                      ]),
                                    ]
                                  ),
                                ]
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _c("Input", {
                        staticClass: "email",
                        attrs: {
                          number: "",
                          size: "large",
                          placeholder: _vm.$t("mobile"),
                        },
                        model: {
                          value: _vm.account,
                          callback: function ($$v) {
                            _vm.account =
                              typeof $$v === "string" ? $$v.trim() : $$v
                          },
                          expression: "account",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "tips" }, [
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.helpUrl,
                  expression: "helpUrl",
                },
              ],
              on: { click: _vm.goHelp },
            },
            [_vm._v(_vm._s(_vm.$t("tips_text")))]
          ),
        ]),
        _c(
          "div",
          { staticClass: "btns" },
          [
            _c(
              "Button",
              {
                class: !_vm.btnEnable ? "disabled" : "",
                attrs: { type: "warning" },
                on: {
                  click: function ($event) {
                    return _vm.clickSendCode()
                  },
                },
              },
              [
                _c("div", [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("get_code")) +
                      " " +
                      _vm._s(_vm.cd > 0 ? `(${_vm.cd}S)` : "") +
                      " "
                  ),
                  _vm.loading
                    ? _c("span", { staticClass: "loading" })
                    : _vm._e(),
                ]),
              ]
            ),
          ],
          1
        ),
        _c("Divider", [_vm._v("OR")]),
        _c(
          "div",
          { staticClass: "social-list", class: _vm.agree ? "" : "disabled" },
          [
            _c("div", {
              staticClass: "item",
              class: _vm.loginType === "mobile" ? "email" : "mobile",
              on: { click: _vm.toggle },
            }),
            _vm.routerParams.from !== "bind" &&
            _vm.routerParams.from !== "yandex_bind"
              ? [
                  _vm._l(_vm.socialLoginTypes, function (item, index) {
                    return [
                      _c(item, {
                        key: index,
                        tag: "components",
                        staticClass: "social-item",
                        attrs: { account: `${_vm.account}` },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.checkAgreement.apply(null, arguments)
                          },
                        },
                      }),
                    ]
                  }),
                ]
              : _vm._e(),
          ],
          2
        ),
      ],
      1
    ),
    _c("div", { staticClass: "agree" }, [
      _c(
        "div",
        { staticClass: "flex flex-horizontal" },
        [
          _c("div", {
            staticClass: "checkbox",
            class: _vm.agree ? "active" : "",
            on: {
              click: function ($event) {
                _vm.agree = !_vm.agree
              },
            },
          }),
          _c(
            "i18n",
            { staticClass: "text", attrs: { path: "text_agree", tag: "div" } },
            [
              _vm._t("0", function () {
                return [
                  _c(
                    "span",
                    {
                      staticClass: "link",
                      on: {
                        click: function ($event) {
                          return _vm.jumpUrl("privacy")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("privacy")))]
                  ),
                ]
              }),
              _vm._t("1", function () {
                return [
                  _c(
                    "span",
                    {
                      staticClass: "link",
                      on: {
                        click: function ($event) {
                          return _vm.jumpUrl("agreement")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("agreement")))]
                  ),
                ]
              }),
            ],
            2
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }